/* eslint-disable no-case-declarations */
// import Vue from "vue";
import mixpanel from '@/third-party/mixpanel-lite';
import store from "@/store";
import moment from "moment-timezone";
import {isJSON} from "@/tools/isJSON";
import {getStorage} from "@/utils/storage";

mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKNE);
const gtag = window.gtag;
gtag('config', process.env.VUE_APP_GTAG)

let hasIdentifyId = false;
let hasUserId = false;

function mixinAttributeAddUserType(type, token) {
    switch (type) {
        case 'null':
            return token ? 'Paid' : 'Not logged';
        case 'freemium':
            return 'Freemium';
        case 'trial':
            return 'Free Trail';
        default:
            return 'Unknown';
    }
}

function mixinTrack(data, params = {}) {
    // esline-disabled-nextline

    let userStore = store.state.user;

    const id = userStore.userId ? (userStore.userId + '') : ''
    let utmObj
    if(isJSON(userStore?.utm)){
        utmObj = JSON.parse(userStore?.utm || '')
      }
    const marketingUtm = userStore.marketingUtm
    const localUtm = getStorage('commandRegistMarketingUtm') || {}
    const peopleProperty = {
        userId: userStore.userId || null,
        'utm_source': marketingUtm?.source || utmObj?.UTM_source || userStore.utm || localUtm.utm_source || "",
        'utm_content': marketingUtm?.content || utmObj?.UTM_content || localUtm.utm_content || "",
        'utm_medium': marketingUtm?.medium || localUtm.utm_medium ||'',
        'utm_campaign': marketingUtm?.campaign|| localUtm.utm_campaign ||'',
        'utm_term': marketingUtm?.term || localUtm.utm_term ||'',
    }
    mixpanel.people.set(peopleProperty)
    if (!hasUserId && userStore.userId) {
        gtag('config', process.env.VUE_APP_GTAG, {
            'user_id': userStore.userId || null
        })
        hasUserId = true
    }
    
    let attributes = Object.assign({}, params, peopleProperty, {
        userId: userStore.userId || null,
        companyCity: userStore.city,
        trialTag: userStore.demoType === 'trial',
        'Device Timezone': moment.tz.guess(),
        'User Status': mixinAttributeAddUserType(String(userStore.demoType), id)
        // trialStatus: userStore.expiredTrialAccount ? 'Expired Trial' : 'Trial',
    });

    if(!hasIdentifyId && id) {
        mixpanel.identify(id)
        hasIdentifyId = true
    }
    gtag('event', data, attributes);
    mixpanel.track(data, attributes);
}

export default function buriedPoints(data, params) {
    // console.log(data)
    switch (data) {
        case 1.0:
            mixinTrack('Register Success', params)
            break
        case 1.1:
            mixinTrack('Login Clicked')
            break
        case 1.2:
            mixinTrack('Forget Password Clicked')
            break
        case 1.3:
            mixinTrack('Command Page Clicked')
            break
        case 1.4:
            mixinTrack('Dashboard Page Clicked')
            break
        case 1.5:
            mixinTrack('Dashboard Page View')
            break
        case 1.6:
            mixinTrack('Dashboard page timecount', params)
            break
        case 1.7:
            mixinTrack('Dashboard_Refreash_Clicked')
            break
        case 1.8:
            mixinTrack('Dashboard_Active Loads_Clicked')
            break
        case 1.9:
            mixinTrack('Dashboard_In Progress Loads_Clicked')
            break
        case 1.91:
            mixinTrack('Dashboard_Assigned Loads_Clicked')
            break
        case 1.92:
            mixinTrack('Dashboard_To be Assigned Loads_Clicked')
            break
        case 1.96:
            mixinTrack('Dashboard_Activity_View All_Clicked')
            break
        case 1.97:
            mixinTrack('Dashboard_Activity_Search_Clicked')
            break
        case 1.98:
            mixinTrack('Dashboard_Activity_Driver name_Clicked')
            break
        case 1.99:
            mixinTrack('Dashboard_Activity_Load ID_Clicked')
            break
        case 1.991:
            mixinTrack('Dashboard_Activity_Terminal name_Clicked')
            break
        case 1.992:
            mixinTrack('Dashboard_Driver_View all_Clicked')
            break
        case 1.993:
            mixinTrack('Dashboard_Driver_Active_Clicked')
            break
        case 1.994:
            mixinTrack('Dashboard_Driver_In Transit_Clicked')
            break
        case 1.995:
            mixinTrack('Dashboard_Driver_Available_Clicked')
            break
        case 1.996:
            mixinTrack('Dashboard_Driver Card_Clicked')
            break
        case 1.997:
            mixinTrack('Dashboard_Load Card_Clicked')
            break
        case 1.998:
            mixinTrack('Dashboard_Overlapping Load Card_Clicked')
            break
        case 1.999:
            mixinTrack('Dashboard_Switch Overlapping Card_Clicked')
            break
        case 2:
            mixinTrack('Map Page Clicked')
            break
         case 2.1:
            mixinTrack('Start Free Trial')
            break
         case 2.2:
            mixinTrack('Sign up')
            break
         case 2.3:
            mixinTrack('Request for Demo')
            break
         case 2.4:
            mixinTrack('Send Route')
            break
        case 2.5:
            mixinTrack('Fuel Plan')
            break
        case 2.6:
            mixinTrack('Save Route')
            break
        case 2.7:
            mixinTrack('Save Route Setting')
            break
        case 2.8:
            mixinTrack('Add Truck')
            break
        case 2.9:
            mixinTrack('Edit Truck')
            break
        case 3:
            mixinTrack('Loads Page Clicked')
            break
        case 3.1:
            mixinTrack('Loads All Clicked')
            break
        case 3.2:
            mixinTrack('Loads Active Clicked')
            break
        case 3.3:
            mixinTrack('Loads To Assign Clicked')
            break
        case 3.4:
            mixinTrack('Loads Assigned Clicked')
            break
        case 3.5:
            mixinTrack('Loads In Progress Clicked')
            break
        case 3.6:
            mixinTrack('Loads Search Origin and Destination Clicked')
            break
        case 3.7:
            mixinTrack('Loads Status Clicked')
            break
        case 3.8:
            mixinTrack('Pickup Date Clicked')
            break
        case 3.9:
            mixinTrack('Delivery Date Clicked')
            break
        case 3.101:
            mixinTrack('Loads Customer Clicked')
            break
        case 3.11:
            mixinTrack('Loads Driver Clicked')
            break
        case 3.12:
            mixinTrack('Loads Equip Type Clicked')
            break
        case 3.13:
            mixinTrack('Loads Add New Load Clicked')
            break
        case 3.131:
            mixinTrack('Loads Save Clicked', params)
            break
        case 3.14:
            mixinTrack('Loads List Clicked')
            break
        case 3.15:
            mixinTrack('Loads Map Clicked')
            break
        case 3.16:
            mixinTrack('Loads Reset Clicked')
            break
        case 3.17:
            mixinTrack('Loads Apply Clicked')
            break
        case 3.18:
            mixinTrack('Loads Export Clicked')
            break
        case 3.19:
            mixinTrack('Loads Edit Clicked')
            break
        case 3.201:
            mixinTrack('Loads Delete Clicked')
            break
        case 3.21:
            mixinTrack('Loads Assign Clicked')
            break
        case 3.22:
            mixinTrack('Loads Reassign Clicked')
            break
        case 3.23:
            mixinTrack('Loads Doc Clicked')
            break
        case 3.24:
            mixinTrack('Load Detail Clicked')
            break
        case 3.241:
            mixinTrack('Load Basic Info Clicked')
            break
        case 3.242:
            mixinTrack('Load Status Clicked', params)
            break
        case 3.243:
            mixinTrack('Load Detail Assign Clicked')
            break
        case 3.244:
            mixinTrack('Load Detail Reassign Clicked')
            break
        case 3.245:
            mixinTrack('Load Customer Info Clicked')
            break
        case 3.246:
            mixinTrack('Load Info Clicked')
            break
        case 3.247:
            mixinTrack('Load Timeline Edit Clicked')
            break
        case 3.248:
            mixinTrack('Load Message')
            break
        case 3.2471:
            mixinTrack('Load Trip Info Clicked')
            break
        case 3.2481:
            mixinTrack('Load Documents Clicked')
            break
        case 3.249:
            mixinTrack('Load Add Doc')
            break
        case 4:
            mixinTrack('Documents Page Clicked')
            break
        case 4.1:
            mixinTrack('Documents All Clicked')
            break
        case 4.2:
            mixinTrack('Documents Load Clicked')
            break
        case 4.3:
            mixinTrack('Documents Driver Clicked')
            break
        case 4.4:
            mixinTrack('Documents All Apply Clicked')
            break
        case 4.5:
            mixinTrack('Documents All Reset Clicked')
            break
        case 4.6:
            mixinTrack('Documents Add New Document Clicked')
            break
        case 4.61:
            mixinTrack('Add Document Saved')
            break
        case 4.7:
            mixinTrack('Documents Action Download Clicked')
            break
        case 4.8:
            mixinTrack('Documents Action Edit Clicked')
            break
        case 4.9:
            mixinTrack('Documents Action Preview Clicked')
            break
        case 4.101:
            mixinTrack('Documents Action Delete Clicked')
            break
        case 4.11:
            mixinTrack('Documents Name Preview Clicked')
            break
        case 5.1:
            mixinTrack('Trucks Page Clicked')
            break
        case 5.11:
            mixinTrack('Truck Add New Truck Clicked')
            break
        case 5.111:
            mixinTrack('Add Truck Saved')
            break
        case 5.12:
            mixinTrack('Truck Import From ELD Clicked')
            break
        case 5.13:
            mixinTrack('Truck Apply Clicked')
            break
        case 5.14:
            mixinTrack('Truck Reset Clicked')
            break
        case 5.15:
            mixinTrack('Truck Export Clicked')
            break
        case 5.16:
            mixinTrack('Truck Detail Clicked')
            break
        case 5.17:
            mixinTrack('Truck Edit Clicked')
            break
        case 5.18:
            mixinTrack('Truck Delete Clicked')
            break
        case 5.2:
            mixinTrack('Trailer Page Clicked')
            break
        case 5.21:
            mixinTrack('Trailer Add New Trailer Clicked')
            break
        case 5.211:
            mixinTrack('Add Trailer Saved')
            break
        case 5.22:
            mixinTrack('Trailer Apply Clicked')
            break
        case 5.23:
            mixinTrack('Trailer Reset Clicked')
            break
        case 5.24:
            mixinTrack('Trailer Export Clicked')
            break
        case 5.161:
            mixinTrack('Trailer Detail Clicked')
            break
        case 5.171:
            mixinTrack('Trailer Edit Clicked')
            break
        case 5.181:
            mixinTrack('Trailer Delete Clicked')
            break
        case 6.1:
            mixinTrack('Basic Info Clicked')
            break
        case 6.11:
            mixinTrack('Setting Profile Clicked')
            break
        case 6.111:
            mixinTrack(' Change Password Clicked')
            break
        case 6.112:
            mixinTrack('Save Clicked')
            break
        case 6.12:
            mixinTrack('Setting Operators Clicked')
            break
        case 6.121:
            mixinTrack('Setting Operators Apply Clicked')
            break
        case 6.122:
            mixinTrack('Setting Operators Reset Clicked')
            break
        case 6.123:
            mixinTrack('Add Operators Clicked')
            break
        case 6.124:
            mixinTrack('Operators Action Edit Clicked')
            break
        case 6.125:
            mixinTrack('Operators Action Delete Clicked')
            break
        case 6.13:
            mixinTrack('Setting Terminals Clicked')
            break
        case 6.131:
            mixinTrack('Create a Terminal Clicked')
            break
        case 6.132:
            mixinTrack('Terminal Detail Clicked')
            break
        case 6.133:
            mixinTrack('Terminal Delete Clicked')
            break
        case 6.2:
            mixinTrack('Customization Clicked')
            break
        case 6.21:
            mixinTrack('Splash Page Clicked')
            break
        case 6.211:
            mixinTrack('Logo Upload Clicked')
            break
        case 6.212:
            mixinTrack('Wallpaper Upload Clicked')
            break
        case 6.213:
            mixinTrack('Apply Changes Clicked')
            break
        case 6.22:
            mixinTrack('Bulletin Clicked')
            break
        case 6.221:
            mixinTrack('Announcement View More Clicked')
            break
        case 6.222:
            mixinTrack('Announcement Add New Clicked')
            break
        case 6.223:
            mixinTrack('Announcement Delete Clicked')
            break
        case 6.224:
            mixinTrack('Announcement Edit Clicked')
            break
        case 6.225:
            mixinTrack('Static Link View More Clicked')
            break
        case 6.226:
            mixinTrack('Static Link Add New Clicked')
            break
        case 6.227:
            mixinTrack('Static Link Delete Clicked')
            break
        case 6.228:
            mixinTrack('Static Link Edit Clicked')
            break
        case 6.229:
            mixinTrack('Files Add New Clicked')
            break
        case 6.22101:
            mixinTrack('Files Download Clicked')
            break
        case 6.2211:
            mixinTrack('Files Delete Clicked')
            break
        case 6.3:
            mixinTrack('Payment and Billing Clicked')
            break
        case 6.31:
            mixinTrack('Manage Subscription Clicked')
            break
        case 6.311:
            mixinTrack('Add/Edit Seats Clicked')
            break
        case 6.312:
            mixinTrack('Startup Dowgrade Clicked')
            break
        case 6.313:
            mixinTrack('Bobtail Upgrade Clicked')
            break
        case 6.314:
            mixinTrack('Bobtail Downgrade Clicked')
            break
        case 6.315:
            mixinTrack('Smokey Upgrade Clicked')
            break
        case 6.316:
            mixinTrack('Smokey Downgrade Clicked')
            break
        case 6.317:
            mixinTrack('Convoy Upgrade Clicked')
            break
        case 6.318:
            mixinTrack('Convoy Downgrade Clicked')
            break
        case 6.319:
            mixinTrack('Contact Us Clicked ')
            break
        case 6.32:
            mixinTrack('Payment Info Clicked')
            break
        case 6.321:
            mixinTrack('Add New Card Clicked')
            break
        case 6.3211:
            mixinTrack('Add New Card Save Clicked')
            break
        case 6.322:
            mixinTrack('Payment Info Delete Clicked')
            break
        case 6.323:
            mixinTrack('Payment Info Set as Default Clicked')
            break
        case 7.1:
            mixinTrack('Browser Height and Width', params)
            break
        case 7.2:
            mixinTrack('Screen Height and Width', params)
            break
        case 7.3:
            mixinTrack('MAP_Send Route_Click Send', params)
            break
        case 7.4:
            mixinTrack('Send Route Text')
            break
        case 7.5:
            mixinTrack('Load Assignment Clicked')
            break
        case 8.1:
            mixinTrack('Enter Search Loads Clicked')
            break
        case 8.2:
            mixinTrack('Search Loads Favorites Tab Clicked')
            break
        case 8.3:
            mixinTrack('Search Loads Search Clicked')
            break
        case 8.4:
            mixinTrack('Search Loads Favorites Clicked')
            break
        case 8.5:
            mixinTrack('Search Loads Create Clicked')
            break
        case 8.6:
            mixinTrack('View Reactive Page', params)
            break
        case 8.7:
            mixinTrack('Outcome Reactive Page', params)
            break
        case 9:
            mixinTrack('View Subscription and Billing Page', params)
            break
        case 9.11:
            mixinTrack('Open Subscribe page', params)
            break
        case 9.2:
            mixinTrack('Outcome Subscribe page', params)
            break
        case 9.3:
            mixinTrack('Successfully Subscribed/Paid', params)
            break
        case 8.8:
            mixinTrack('Watch Video Results', params)
            break
        case 8.81:
            mixinTrack('Begin Task Results', params)
            break
        case 8.82:
            mixinTrack('Other Results Onboarding Portal', params)
            break
        case 8.83:
            mixinTrack('Complete Task Results', params)
            break
        case 10.1:
            mixinTrack('DocView_PageView', params)
            break
        case 10.11:
            mixinTrack('DocView_SignUp', params)
            break
        case 10.12:
            mixinTrack('DocView_Reactive', params)
            break
        case 10.13:
            mixinTrack('DocView_ViewAll')
            break
        case 10.14:
            mixinTrack('DocView_SignUp_Next')
            break
        case 10.15:
            mixinTrack('DocView_SignUp_Submit')
            break
        case 10.16:
            mixinTrack('DocView_SignUp_AddDriver', params)
            break
        case 10.17:
            mixinTrack('Fleet Schedule Clicked')
            break
        case 10.18:
            mixinTrack('FleetSchedule_AddNewDriverSuccess', params)
            break
        // case 10.19:
        //     mixinTrack('Fleet Schedule Clicked')
        //     break
        
        case 10.2:
            mixinTrack('View ELD Integration page')
            break
        case 10.21:
            mixinTrack('Outcome ELD integration authorize', params)
            break
        case 10.22:
            mixinTrack('Outcome ELD integration match', params)
            break
        case 10.23:
            mixinTrack('Eld - submit after adding an account')
            break
        case 10.25:
            mixinTrack('Driver Page Clicked')
            break
        case 10.26:
            mixinTrack('Driver Active Clicked')
            break
        case 10.27:
            mixinTrack('Driver Available Clicked')
            break
        case 10.28:
            mixinTrack('Driver In Transit Clicked')
            break
        case 10.29:
            mixinTrack('Driver All Clicked')
            break
        case 10.30:
            mixinTrack('Driver Team Clicked')
            break
        case 10.3:
            mixinTrack('Add Driver Clicked')
            break
        case 10.31:
            mixinTrack('Add Driver Add New Clicked')
            break
        case 10.32:
            mixinTrack('Add Driver Save Clicked', params)
            break
        case 10.33:
            mixinTrack('Driver List Clicked')
            break
        case 10.34:
            mixinTrack('Driver Map Clicked')
            break
        case 10.35:
            mixinTrack('Driver Export Clicked')
            break
        case 10.36:
            mixinTrack('Driver Detail Clicked')
            break
        case 10.37:
            mixinTrack('Driver Detail Basic Info Clicked')
            break
        case 10.38:
            mixinTrack('Driver Detail Load History Clicked')
            break
        case 10.39:
            mixinTrack('Driver Detail Profile Clicked')
            break
        case 10.4:
            mixinTrack('Driver Detail Payment Terms Clicked')
            break
        case 10.41:
            mixinTrack('Driver Detail Documents Clicked')
            break
        case 10.42:
            mixinTrack('Driver Activity Clicked')
            break
        case 10.43:
            mixinTrack('Driver Message Clicked')
            break
        case 10.44:
            mixinTrack('Driver Edit Clicked')
            break
        case 10.45:
            mixinTrack('Driver Deactivate Clicked')
            break
        case 10.46:
            mixinTrack('Driver Delete Clicked')
            break
        case 10.47:
            mixinTrack('HOS Clicked')
            break
        case 10.48:
            mixinTrack('Driver Activate Clicked')
            break
        case 10.49:
            mixinTrack('Driver Edit Saved')
            break
        case 10.5:
            mixinTrack('Settlement Page Clicked')
            break
        case 10.51:
            mixinTrack('Settlement_CreateNewSettlement Clicked')
            break
        case 10.52:
            mixinTrack('Settlement_AddLoadSettlement')
            break
        case 10.53:
            mixinTrack('Settlement_AddAdjustment')
            break
        case 10.54:
            mixinTrack('Settlement_PaymentReport Clicked')
            break
        case 10.55:
            mixinTrack('Settlement_EmailClicked')
            break
        case 10.56:
            mixinTrack('Settlement_EmailSent')
            break
        case 10.57:
            mixinTrack('Settlement_EmailPaymentReport', params)
            break
        case 10.6:
            mixinTrack('Message page Clicked')
            break
        case 11:
            mixinTrack('Expense Page Clicked')
            break
        case 11.1:
            mixinTrack('Expense_BatchMarking')
            break
        case 11.11:
            mixinTrack('Expense_AddNewExpense')
            break
        case 11.12:
            mixinTrack('Expense_AddNewCategory', params)
            break
        case 11.13:
            mixinTrack('Expense_ExportData')
            break
        case 12.1:
            mixinTrack('Map Route Button')
            break
        case 12.2:
            mixinTrack('Route Create', params)
            break
        case 12.5:
            mixinTrack('Message_AddGroupChat Clicked')
            break
        case 12.51:
            mixinTrack('Message_AddGroupChat Completed', params)
            break
        case 12.52:
            mixinTrack('Message_GroupChat_MoreFunctions', params)
            break
        case 12.53:
            mixinTrack('Message_Rename')
            break
        case 12.54:
            mixinTrack('Message_ViewMembers')
            break
        case 12.55:
            mixinTrack('Message_AddMembers Clicked')
            break
        case 12.56:
            mixinTrack('Message_AddMembers Completed')
            break
        case 12.57:
            mixinTrack('SendTextMessage')
            break
        case 12.58:
            mixinTrack('SendImageMessage')
            break
        case 12.59:
            mixinTrack('SendAudioMessage')
            break
        case 13:
            mixinTrack('Trial Registration Results Command Page', params)
            break
        case 13.1:
            mixinTrack('Contact_add customer', params)
            break
        case 13.2:
            mixinTrack('Contact_view customer details', params)
            break
        case 13.3:
            mixinTrack('Contact_add documents', params)
            break
        case 13.4:
            mixinTrack('Contact_add contact for customer', params)
            break
        case 13.5:
            mixinTrack('Settlement_Set payment term')
            break
        case 13.51:
            mixinTrack('Settlement_Click Finalize')
            break
        case 13.52:
            mixinTrack('Settlement_Click Revert')
            break
        case 13.53:
            mixinTrack('Settlement_Preview Unfinalized PDF')
            break
        case 13.54:
            mixinTrack('Settlement_add load rate')
            break
        case 13.55:
            mixinTrack('Settlement_add schedule pay')
            break
        case 13.56:
            mixinTrack('Settlement_add schedule deduction')
            break
        case 14.1:
            mixinTrack('Invoice page clicked')
            break
        case 14.2:
            mixinTrack('Invoice_create invoice clicked')
            break
        case 14.3:
            mixinTrack('Invoice_add factoring company')
            break
        case 14.4:
            mixinTrack('Invoice_Preview PDF')
            break
        case 14.5:
            mixinTrack('Invoice_Download PDF')
            break
        case 14.6:
            mixinTrack('Invoice_save as draft')
            break
        case 14.7:
            mixinTrack('Invoice_send invoice', params)
            break
        case 14.8:
            mixinTrack('Invoice_Mark as paid', params)
            break
        case 14.9:
            mixinTrack('Team Driver_Create Team', params)
            break
        case 15:
            mixinTrack('Share Trip_login popup', params)
            break
        case 15.1:
            mixinTrack('Share Trip_registration success', params)
            break
        case 15.2:
            mixinTrack('Share Trip_Click Send Document')
            break
        case 15.3:
            mixinTrack('Share Trip_Click Check Call')
            break
        case 15.4:
            mixinTrack('Share Trip_Click Add new doc')
            break
        case 15.5:
            mixinTrack('Share Trip_Click TopRight CTA')
            break
        case 15.6:
            mixinTrack('Share Trip_Send Document', params)
            break
        case 15.7:
            mixinTrack('Share Trip_Send Check Call', params)
            break
        case 15.8:
            mixinTrack('Share Trip_Refresh Page')
            break
        case 15.9:
            mixinTrack('Share Trip_Locate Driver')
            break
        case 15.11:
            mixinTrack('Share Trip_ Add to fleet')
            break
        case 15.12:
            mixinTrack('Share Trip_ Delete Doc')
            break
        case 15.13:
            mixinTrack('Share Trip_Send Message')
            break
        case 15.14:
            mixinTrack('Share Trip_ Check POI')
            break
        case 15.15:
            mixinTrack('Share Trip_Open link')
            break
        case 15.16:
            mixinTrack('Share Trip_Register email sent')
            break
        case 16.0:
            mixinTrack('Team Driver_Assign Team')
            break;
        case 16.1:
            mixinTrack('Team Driver_Switch driver display')
            break;
        case 17:
            mixinTrack('ELD_Account Integration_Add Account_Clicked', params)
            break;
        case 17.1:
            mixinTrack('ELD_Account Integration_Add Account_Submit_Clicked', params)
            break;

        case 18.1:
            mixinTrack('click_TLpremium_submit', params)
            break;
        case 18.2:
            mixinTrack('click_TLpremium_success', params)
            break;
        case 18.3:
            mixinTrack('click_subscribe_LB')
            break;

        case 18.4:
            mixinTrack('Freemium_Register popup', params)
            break;
        case 18.5:
            mixinTrack('Freemium_Register email sent')
            break;
        case 18.6:
            mixinTrack('Freemium_Click Activate')
            break;
        case 18.7:
            mixinTrack('Freemium_Activate Success')
            break;
        case 18.8:
            mixinTrack('Freemium_Start Trial popup', params)
            break;
        case 18.9:
            mixinTrack('Freemium_Start Trial Success')
            break;
        case 18.11:
            mixinTrack('Freemium_Click Add Card')
            break;
        case 18.12:
            mixinTrack('Freemium_Click Prepaid')
            break;
        case 18.13:
            mixinTrack('Freemium_Click Subscribe', params)
            break;
        case 18.14:
            mixinTrack('Freemium_Explore COMMAND', params)
            break;
        case 19.00:
            mixinTrack('Dialer-Click Phone Icon')
            break;
        case 19.01:
            mixinTrack('Dialer - Click Dialer Settings')
            break;
        case 19.02:
            mixinTrack('Dialer - Click Module Activity', params)
            break;
        case 19.03:
            mixinTrack('Dialer - Click Call', params)
            break;
        case 19.04:
            mixinTrack('Subscription-Click Subscription')
            break;
        case 19.05:
            mixinTrack('Subscription- Assign (Operator) Subscription')
            break;
        case 19.06:
            mixinTrack('Subscription- Assign (Operator) Seats')
            break;
        case 19.07:
            mixinTrack('Subscription- Save (Operator) Seats')
            break;
        case 19.08:
            mixinTrack('Subscription-Click Billing')
            break;
        case 19.09:
            mixinTrack('Subscription-Edit Card')
            break;
        case 19.10:
            mixinTrack('Subscription- Assign Driver Subscription')
            break;
        case 19.11:
            mixinTrack('Subscription- Assign Driver Seats')
            break;
        case 19.12:
            mixinTrack('Subscription- Save Driver Seats')
            break;
        case 19.13:
            mixinTrack('Biling-See Detail')
            break;
        case 21:
            mixinTrack('PageView')
            break;
        case 21.1:
            mixinTrack('Share Trip_Back to map')
            break;
        case 21.2:
            mixinTrack('Share Trip_Register email sent')
            break;
        case 21.3:
            mixinTrack('Share Trip_Send Note')
            break;

        case 21.4:
            mixinTrack('Expense_Fuel')
            break;
        case 21.5:
            mixinTrack('Expense_Fuel_RefreshData')
            break;
        case 21.6:
            mixinTrack('Expense_Fuel_RefreshData_ConnectFuelCardEmptyState')
            break;
        case 21.7:
            mixinTrack('Expense_Fuel_RefreshData_ConnectFuelCardEmptyState_GoToConnect')
            break;
        case 21.8:
            mixinTrack('Expense_Fuel_FilterDate')
            break;
        case 21.9:
            mixinTrack('Expense_Fuel_FilterDate_DateShortcutClicked', params)
            break;
        case 21.11:
            mixinTrack('Expense_Fuel_AddFuelExpenseClicked')
            break;
        case 21.12:
            mixinTrack('Expense_Fuel_AddFuelExpenseSaved')
            break;
        case 21.13:
            mixinTrack('Expense_Fuel_EditFuelExpenseClicked', params)
            break;
        case 21.14:
            mixinTrack('Expense_Fuel_EditFuelExpenseSaved', params)
            break;
        case 21.15:
            mixinTrack('Expense_Fuel_EmptyStateGettingMileage', params)
            break;
        case 22.1:
            mixinTrack('Book Meeting_Click', params)
            break;
        // wallet payment setting related use number 23.xxx
        case 23.1:
            mixinTrack('In App Payment Set Up', params)
            break;
        case 23.2:
            mixinTrack('Onboarding Popup Get Started Click', params)
            break;
        
        case 23.01:
            mixinTrack('New Dashboard_Navigation')
            break
        case 24.1:
            mixinTrack('MAP_DragRoute')
            break;
        case 24.2:
            mixinTrack('MAP_Click Fuel Plan', params)
            break
        case 24.3:
            mixinTrack('MAP_Fuel Plan_Click Apply to Trip', params)
            break
        case 24.4:
            mixinTrack('MAP_Fuel Plan_Click Remove')
            break
        case 24.5:
            mixinTrack('MAP_Click Send Route', params)
            break
        case 24.6:
            mixinTrack('Load_Turn Route to Load Clicked')
            break  
        case 25.1:
            mixinTrack('Subscription and Billing_Click Cancel Subscription', params)
            break
        case 25.2:
            mixinTrack('Subscription and Billing_Trial Cancel Popup Open')
            break
        case 25.3:
            mixinTrack('Subscription and Billing_Trial Cancel Popup_Click Send to Get Help')
            break
        case 25.4:
            mixinTrack('Subscription and Billing_Trial Cancel Popup_Click No Please Cancel')
            break
        case 25.5:
            mixinTrack('Subscription and Billing_Trial Cancel Confirmation Popup Open')
            break
        case 25.6:
            mixinTrack('Subscription and Billing_Trial Cancel Confirmation Popup_Click Confirm Cancel')
            break
        case 25.7:
            mixinTrack('Subscription and Billing_Subscriber Request Cancel Popup Open')
            break
        case 25.8:
            mixinTrack('Subscription and Billing_Subscriber Request Cancel Popup_Click Submit')
            break
        case 26.1:
            mixinTrack('Fuel Plan Popup Open')
            break
        case 26.2:
            mixinTrack('Fuel Plan Popup_Conduct Test', params)
            break
        case 26.3:
            mixinTrack('Fuel Plan Popup_Click View Fuel Plan Details', params)
            break
        case 26.4:
            mixinTrack('Fuel Plan Popup_Click Reset to Try Again', params)
            break
        case 26.5:
            mixinTrack('Fuel Plan Popup_Click View Trip Details')
            break
        case 26.6:
            mixinTrack('Apply Fuel Plan Bubble Open')
            break
        case 26.7:
            mixinTrack('Apply Fuel Plan Bubble_Click Apply Now')
            break
        case 26.0:
            mixinTrack('Send Route to Driver Popup Open', params)
            break
    }
}
